import React from 'react';

export default function CheckBox(props) {
    const {form, field} = props;
    return (
        <>
            <div className={`${props.mydisabled?'':'my-2'}`}>
                <label className="inline-flex items-center cursor-pointer mt-10">
                    <input
                        name={props.name}
                        type="checkbox"
                        className="form-checkbox border-1-gray-800   rounded mx-1 text-gray-800 ml-1 w-5 h-5"
                        style={{
                            transition: 'all 0.15s ease 0s',
                        }}
                        {...field}
                        checked={!!field.value}
                    />
                    <span className="ml-2 text-sm font-semibold text-gray-700">{props.label}</span>
                </label>
                {form.errors[field.name] && form.touched[field.name] && form.errors[field.name]}
            </div>
        </>

    );
}
